export default __webpack_public_path__ + "static/media/Boots of the Sanguine Disciple.d49a94fe.jpg";